<template>
  <div>
    <div
      id="tabs"
      class="container flex flex-wrap h-auto pt-8 pb-4 tb mx-auto md:flex-wrap lg:justify-center"
      :class="{'pt-0 pb-8 justify-center' : !showSteps}"
    >
      <div class="flex flex-col items-center justify-center w-full py-3 lg:w-1/3 lg:py-0">
        <p
          class="text-base font-semibold leading-tight text-black"
          v-html="$t('messages.profile_tabs.profile', {percentage: Number(this.total_percent).toFixed(0)})"
        ></p>
        <a
          v-on:click="emitToParent"
          class="mb-4 font-bold no-underline cursor-pointer text-jblue-secondary hover:text-blue-700"
        >{{ seen ? $t('messages.profile_tabs.go_back') : $t('messages.profile_tabs.complete_profile') }}</a>
      </div>
      <div
        v-if="showSteps"
        class="relative items-start hidden w-full steps-wrapper md:flex lg:flex xl:flex lg:w-2/3"
        :class="seen ? 'steps-wrapper' : 'steps-wrapper-unseen'"
      >
        <template v-for="(step, index) in steps">
          <a
            class="flex items-center justify-center w-1/6 p-2 step"
            :key="index"
            v-on:click="setSelectedTab(step)"
            v-bind:class="[ activetab === step.order ? 'active' : '']"
          >
            <div class="flex flex-col items-center justify-center">
              <div class="circle" style="height:24px;">
                <i :class="[step.icon, step.class]"></i>
              </div>
              <div class="step-title">
                <p
                  class="text-sm"
                >{{ $t(`messages.profile_tabs.steps.${step.translated}`) }}</p>
              </div>
            </div>
          </a>
        </template>
      </div>
      <div v-if="seen" class="block w-full mx-6 md:hidden lg:hidden xl:hidden">
        <div class="relative w-full">
          <div
            @click="open"
            class="w-full px-4 py-3 text-base text-black bg-blue-bezalel border-none cursor-pointer"
          >
            <div v-if="picked == ''" class="flex items-center justify-center">
              <span class="text-center text-white font-bold">{{$t('messages.choose_step')}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 ml-2 text-white font-bold">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
              </svg>
            </div>
            <div v-else>
              <i :class="[picked.icon, picked.class]"></i>
              {{ picked.title }}
            </div>
          </div>
          <div
            id="options_steps"
            class="absolute z-10 w-full overflow-auto bg-gray-300 dropdown-content"
          >
            <template>
              <label
                v-for="(step, index) in steps"
                class="block px-4 py-3 font-bold text-gray-700 bg-gray-300 cursor-pointer hover:bg-gray-400"
                @click="close"
                :key="index"
                v-on:click="activetab=step.order"
                :for="index"
              >
                <div class="flex items-center justify-center">
                  <div class="mr-2 circle">
                    <i v-if="step.completed === true" class="complete" :class="step.icon"></i>
                    <i v-else-if="step.completed === false" class="incomplete" :class="step.icon"></i>
                    <i v-else class="empty" :class="step.icon"></i>
                  </div>
                  <div class="step-title">
                    <h4 class>{{ $t(`messages.profile_tabs.steps.${step.translated}`) }}</h4>
                  </div>
                </div>
              </label>
            </template>
          </div>
        </div>
      </div>
      <div v-if="seen" class="w-full content">
        <div v-if="seen" class="justify-center w-full px-12 my-2 text-center">
        <button
          class="inline-block w-64 py-1 mb-1 font-bold text-center text-white bg-pink-500 border border-pink-500 rounded button is-link hover:bg-white hover:text-pink-500 is-success"
          @click="saveData"
        >{{ $t('messages.profile_tabs.save') }}</button>
        <p>
          <a
          v-on:click="emitToParent"
          class="mb-4 font-bold no-underline cursor-pointer text-jblue-secondary hover:text-blue-700"
        >{{ seen ? $t('messages.profile_tabs.go_back') : $t('messages.profile_tabs.complete_profile') }}</a>
        </p>
      </div>
        <step-one :loading="isLoading" v-if="activetab === 1" ref="StepOne" />
        <step-two :loading="isLoading" v-if="activetab === 2" ref="StepTwo" />
        <step-three :loading="isLoading" v-if="activetab === 3" ref="StepThree" />
        <step-four :loading="isLoading" v-if="activetab === 4" ref="StepFour" />
        <step-five :loading="isLoading" v-if="activetab === 5" ref="StepFive" />
        <step-six :loading="isLoading" v-if="activetab === 6" ref="StepSix" />
      </div>
      <div v-if="seen" class="justify-center w-full px-12 my-10 text-center">
        <button
          class="inline-block w-1/3 py-3 mb-6 font-bold text-center text-white bg-pink-500 border border-pink-500 rounded button is-link hover:bg-white hover:text-pink-500 is-success"
          @click="saveData"
        >{{ $t('messages.profile_tabs.save') }}</button>
        <p>
          <a
          v-on:click="emitToParent"
          class="mb-4 font-bold no-underline cursor-pointer text-jblue-secondary hover:text-blue-700"
        >{{ seen ? $t('messages.profile_tabs.go_back') : $t('messages.profile_tabs.complete_profile') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import StepOne from "@/components/StepOne.vue";
import StepTwo from "@/components/StepTwo.vue";
import StepThree from "@/components/StepThree.vue";
import StepFour from "@/components/StepFour.vue";
import StepFive from "@/components/StepFive.vue";
import StepSix from "@/components/StepSix.vue";
import bus from "@/bus";

export default {
  name: "Tabs",
  props: {
    steps: {
      type: Array,
      default: () => {
        return [
          {
            icon: "icon-step-one",
            name: "prueba",
            title: "Información personal",
            translated: "personal_information",
            order: 1,
            component: StepOne,
            ref: "StepOne",
            completed: "",
            class: "completed"
          },
          {
            icon: "icon-step-two",
            name: "prueba",
            title: "Descripción",
            translated: "about_you",
            order: 2,
            component: StepTwo,
            ref: "StepTwo",
            completed: "",
            class: "completed"
          },
          {
            icon: "icon-step-three",
            name: "prueba",
            title: "Educación",
            translated: "education",
            order: 3,
            component: StepThree,
            ref: "StepThree",
            completed: true,
            class: "completed"
          },
          {
            icon: "icon-step-five",
            name: "prueba",
            title: "Mi pareja ideal",
            translated: "my_ideal_couple",
            order: 4,
            component: StepFour,
            ref: "StepFour",
            completed: false,
            class: "completed"
          },
          {
            icon: "icon-step-six-2",
            name: "prueba",
            title: "Más sobre mí",
            translated: "more_about_me",
            order: 5,
            component: StepFive,
            ref: "StepFive",
            completed: false,
            class: "completed"
          },
          {
            icon: "icon-step-four",
            name: "prueba",
            title: "Tu fotografia",
            translated: "your_picture",
            order: 6,
            component: StepSix,
            ref: "StepSix",
            completed: true,
            class: "completed"
          }
        ];
      }
    }
  },
  data() {
    return {
      number: 1,
      total_percent: 0,
      activetab: 1,
      seen: false,
      picked: "",
      showSteps: true,
      isLoading: false,
      age_range: [],
      watchedInputs: ['username','profile_message', 39, 40, 43, 48],
      editedInputs: [],
      shouldBePending: false
    };
  },
  async mounted() {
    await this.fetchUser();
    await this.showAnswersUsers(this.user.id);
    await this.calculateStepPercent();

    const params = this.$route.params;
    const { start_age, end_age } = this.user.profile;

    this.age_range = [start_age, end_age];

    if (params.edit === 'yes') {
      this.emitToParent();
    }

    bus.$on('age_range_changed', range => {
      this.age_range = range;
    });

    bus.$on('input-changed', from => {
      if (this.watchedInputs.includes(from)) {
        this.shouldBePending = true;

        let field;

        switch(from) {
          case 39:
            field = 'self_description';
            break;
          case 40:
            field = 'match_description';
            break;
          case 43:
            field = 'privileges';
            break;
          case 48:
            field = 'spiritual_goals';
            break;
          default:
            field = from;
            break;
        }

        const inputs = [...this.editedInputs, field];
        this.editedInputs = _.uniq(inputs);
      }
    });
  },
  computed: {
    ...mapState("answer", ["answers"]),
    ...mapState("answers", ["answers_user"]),
    ...mapState("auth", ["user"])
  },
  methods: {
    ...mapActions("answer", ["updateAnswers"]),
    ...mapActions("answers", ["showAnswersUsers"]),
    ...mapActions("auth", ["updateUser", "fetchUser", "updateRevision"]),
    setSelectedTab(step) {
      if (this.activetab !== step.order) {
        this.editedInputs = [];
        this.shouldBePending = false;
      }

      return this.seen ? this.activetab = step.order : '';
    },
    open() {
      document.getElementById("options_steps").classList.toggle("show");
    },
    close() {
      document.getElementById("options_steps").classList.remove("show");
    },
    calculateStepPercent() {
      let stepOneCounter = 7;
      let stepTwoCounter = 0;
      let stepTwoQuestions = 0;
      let stepThreeCounter = 0;
      let stepThreeQuestions = 0;
      let stepFourCounter = 0;
      let stepFourQuestions = 0;
      let stepFiveCounter = 0;
      let stepFiveQuestions = 0;
      if (this.user.profile.phone_mobile !== null) {
        stepOneCounter++;
      }
      if (this.user.profile.zip_code !== null) {
        stepOneCounter++;
      }
      let stepOnePercent = (stepOneCounter / 9) * 100;
      this.answers_user.about_you.subcategories.map(function(subcategory) {
        stepTwoQuestions += subcategory.questions.length;
        let current_answers = subcategory.questions.filter(
          data => data.answer.length > 0
        );
        stepTwoCounter += current_answers.length;
      });

      this.answers_user.education.subcategories.map(function(subcategory) {
        stepThreeQuestions += subcategory.questions.length;
        let current_answers = subcategory.questions.filter(
          data => data.answer.length > 0
        );
        stepThreeCounter += current_answers.length;
      });

      this.answers_user.ideal_couple.subcategories.map(function(subcategory) {
        stepFourQuestions += subcategory.questions.length;
        let current_answers = subcategory.questions.filter(
          data => data.answer.length > 0
        );
        stepFourCounter += current_answers.length;
      });

      this.answers_user.more_about_you.subcategories.map(function(subcategory) {
        stepFiveQuestions += subcategory.questions.length;
        let current_answers = subcategory.questions.filter(
          data => data.answer.length > 0
        );
        stepFiveCounter += current_answers.length;
      });

      if (stepTwoQuestions == 0) {
        stepTwoCounter = 1;
        stepTwoQuestions = 1;
      }
      if (stepThreeQuestions == 0) {
        stepThreeCounter = 1;
        stepThreeQuestions = 1;
      }
      if (stepFourQuestions == 0) {
        stepFourCounter = 1;
        stepFourQuestions = 1;
      }
      if (stepFiveQuestions == 0) {
        stepFiveCounter = 1;
        stepFiveQuestions = 1;
      }
      let stepTwoPercent = (stepTwoCounter / stepTwoQuestions) * 100;
      let stepThreePercent = (stepThreeCounter / stepThreeQuestions) * 100;
      let stepFourPercent = (stepFourCounter / stepFourQuestions) * 100;
      let stepFivePercent = (stepFiveCounter / stepFiveQuestions) * 100;
      let stepSixPercent =
        this.user.pictures.length == 0
          ? 0
          : this.user.pictures.length == 1
          ? 50
          : 100;
      this.total_percent =
        (stepOnePercent +
          stepTwoPercent +
          stepThreePercent +
          stepFourPercent +
          stepFivePercent +
          stepSixPercent) /
        6;
      this.steps[0].class =
        stepOnePercent < 50
          ? "empty"
          : stepOnePercent >= 50 && stepOnePercent <= 70
          ? "incomplete"
          : "complete";
      this.steps[1].class =
        stepTwoPercent < 50
          ? "empty"
          : stepTwoPercent >= 50 && stepTwoPercent <= 70
          ? "incomplete"
          : "complete";
      this.steps[2].class =
        stepThreePercent < 50
          ? "empty"
          : stepThreePercent >= 50 && stepThreePercent <= 70
          ? "incomplete"
          : "complete";
      this.steps[3].class =
        stepFourPercent < 50
          ? "empty"
          : stepFourPercent >= 50 && stepFourPercent <= 70
          ? "incomplete"
          : "complete";
      this.steps[4].class =
        stepFivePercent < 50
          ? "empty"
          : stepFivePercent >= 50 && stepFivePercent <= 70
          ? "incomplete"
          : "complete";
      this.steps[5].class =
        this.user.pictures.length == 0
          ? "empty"
          : this.user.pictures.length == 1
          ? "incomplete"
          : "complete";
    },
    emitToParent() {
      this.seen = !this.seen;
      // this.showSteps = !this.showSteps;
      this.$emit("childToParent", this.seen);
      window.scrollTo(0, 0);
    },
    async saveData() {
      try {
        if (await this.$root.$validator.validate(`step${this.activetab}.*`) ) {
          this.isLoading = true;

          if (this.activetab === 1) {
            let form = await this.$refs.StepOne.getData();

            Vue.rollbar.debug('Editing profile data', {
              tab: this.activetab,
              user_id: this.user.id,
              form
            });

            await this.updateUser(form);
            await this.fetchUser(true);
          }

          if (this.activetab === 4) {
            await this.updateUser({ id: this.user.id, range_age: this.age_range });
            await this.fetchUser(true);
          }

          if (this.activetab === 6) {
            await this.$refs.StepSix.createPictures();
          }

          let answers = { questions: this.answers };

          Vue.rollbar.debug('Editing profile data', {
            tab: this.activetab,
            user_id: this.user.id,
            answers: answers
          });

          if (this.shouldBePending) {
            await this.updateRevision(this.editedInputs.join(' | '));
            this.editedInputs = [];
            this.shouldBePending = false;
          }

          await this.updateAnswers(answers);
          await this.showAnswersUsers(this.user.id);
          await this.calculateStepPercent();
          await this.fetchUser(true);

          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
        } else {
          this.errors.items.forEach(error => {
            this.$toasted.show(error.msg, {
              type: 'error',
              duration: 6000,
              position: 'bottom-right',
            });
          })
        }
      } catch (e) {
        Vue.rollbar.error('Editing profile data', {
            tab: this.activetab,
            user_id: this.user.id,
            answers: this.answers
          });
        return e;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.dropbtn {
  background-color: #3498db;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.dropdown-content {
  display: none;
}
.show {
  display: block !important;
}
.complete {
  color: #1faa00;
}
.incomplete {
  color: #ee9530;
}
.empty {
  color: #d50000;
}
.steps-wrapper {
  left: 0;
}

.step {
  opacity: 0.4;
}

.steps-wrapper a:hover {
  opacity: 1;
  cursor: pointer;
}

.steps-wrapper a.active {
  opacity: 1;
  cursor: default;
}

.steps-wrapper-unseen {
  left: 0;
}

.steps-wrapper-unseen a:hover {
  opacity: 0.4;
  cursor: default;
}

.steps-wrapper-unseen a.active {
  opacity: 0.4;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
}
.step {
  position: relative;
  display: flex;
  //flex-direction: column;
  align-items: center;
  text-align: center;
  // @include breakpoint(xs) {
  //   width: 100% !important;
  // }
  &.deactivated {
    // @include breakpoint(xs) {
    //   display: none;
    // }
    .circle {
      i {
        background-color: #bbbbbb !important;
      }
    }
    .step-title {
      opacity: 0.35;
    }
  }
  .circle {
    margin-bottom: 1rem;
    padding: 0 1rem;
    i {
      background-color: #f0f0f0;

      border-radius: 100rem;
      padding: 1rem;
    }
  }
  .step-title {
    top: 90%;
    width: 100%;
    h1,
    h2,
    h3,
    h4,
    h5 {
      margin: 0 0 0.2rem 0;
      color: #333333;
      font-weight: bold;
    }
    .step-subtitle {
      font-weight: lighter;
      margin: 0;
      color: #555555;
    }
  }
}
</style>
